import { ProductListViewModel } from '@/types/api'

import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines'

import { PLPCardProps } from '../types'

export const generateProductCardProps = (
    data: ProductListViewModel,
    indexInSinglePage: number,
    pageNumber: number | null
): PLPCardProps => {
    const indexInAllPages = pageNumber ? (Number(pageNumber) - 1) * 24 + indexInSinglePage : indexInSinglePage

    const plpCardProps = {
        ad: data.ad,
        brand: data.brand?.nameFa || data.brand?.nameEn || '',
        colorsCount: data.colorsCount || 0,
        image: data.imageUrl || '',
        name: data.nameFa || data.nameEn || '',
        slug: data.slug || '',
        pricingProps: {
            basePrice: data.basePrice,
            discountPercent: data.discountPercent,
            effectivePrice: data.effectivePrice,
        },
        hasGift: data.flags?.includes('Gift'),
        flags: data.flags?.split(', '),
        isLazy: indexInSinglePage > 6 && !PUBLIC_IS_BOT ? true : false,
        isSalable: data.isSalable || false,
        id: data.ad ? `${data.id}-ad` : data.id || '',
        indexInSinglePage,
        indexInAllPages,
    }

    return plpCardProps
}
